import Tooltip from 'rc-tooltip'
import React from 'react'
import 'rc-tooltip/assets/bootstrap.css'

import * as S from './styles'

/**
 * @typedef {Object} TooltipProps
 * @property {string} text
 * @property {React.ReactNode} children
 * @property {boolean} [visible]
 * @property {'left' | 'center' | 'right'} [textAlign]
 */

/**
 * @param {TooltipProps} props
 */
export const CustomTooltip = ({ text, children, visible, textAlign }) => {
  return (
    <Tooltip
      visible={visible}
      overlay={
        <S.TooltipContent textAlign={textAlign}>{text}</S.TooltipContent>
      }
      placement="bottom"
      trigger="hover"
      destroyTooltipOnHide
      mouseEnterDelay={0.3}
      overlayInnerStyle={{
        color: '#FFF',
        borderRadius: '5px',
        background: '#5b605d',
        fontSize: '14px',
        width: 'max-content',
        minHeight: 'auto',
        padding: '4px 8px'
      }}
    >
      {children}
    </Tooltip>
  )
}
